
export { useDeviceType } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/hooks/src/lib/useDeviceType.ts"
export { useMediaQuery } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-consumer-deploy-prod/libs/shared/hooks/src/lib/useMediaQuery.ts"